ol.rds-ordered-list,
ul.rds-unordered-list {
  padding-left: var(--rds-padding-100);
}

ol.rds-ordered-list li,
ul.rds-unordered-list li {
  font-size: var(--rds-font-size-md);
  line-height: var(--rds-line-height-md);
  padding-left: 0;
}

ul.rds-unordered-list li::before {
  margin-left: -16px;
  width: var(--rds-padding-100);
}

p.random-reader-instructions li span.visibility-hidden {
  visibility: hidden;
}

p.random-reader-instructions li:last-child {
  margin-bottom: 0;
}

img.random-reader-image {
  width: 140px;
}

.voice-rate-slow {
  voice-rate: slow;
  speech-rate: slow;
}

.digits {
  speak-as: digits;
}
